import style from "@/styles/pages/ConfirmApplication/ConfirmApplication.module.css";
import { RootState } from "@/store/dtm";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useEffect } from "react";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useNavigate } from "react-router-dom";
import { verificationCategory } from "@/types/applicationType";
import { setIdVerificationStatus } from "@/slices/applicantSlice";
import { createApiClient } from "@/lib/Requests";
import { ApplicationDto } from "@/lib/DTMWebAPIClient.generated";
import { setSingleClickInsightEvent } from "@/lib/util";

export default function ConfirmIDSubmission() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const application = useSelector(
    (state: RootState) => state.application.application
  );

  const credential = useSelector((state: RootState) => state.credential);

  const client = createApiClient({ timeout: 60000, token: credential.credential.accessToken });

  useEffect(() => {
    document.title = "ID Submission";
    setSingleClickInsightEvent("IDVerificationComplete", "pending");
    dispatch(setIdVerificationStatus(verificationCategory.Processing));

    client.apiApplicationsFetch().then((result) => {
      result.application = application;
      client.apiApplicationsSave(new ApplicationDto({
        applicationData: JSON.stringify(result)
      })).catch((error) => {
        console.log("Error saving application info");
      });
    }).catch((error) => {
      console.log("Error fetching application info");
    });
    //setClickInsightEvents(application);
  }, []);

  const handleClick = () => {
    navigate('/home', { replace: true });
  }

  return (
    <FadeTransition>
      <main aria-labelledby="main-content">
        <div className="main-container max-md:mt-10">
          <div className={style.contentContainer}>
            <div className="flex flex-col max-xs:px-3 max-md:items-center">
              <div className={style.emHeading}>
                <div className="grid grid-cols-1">
                  <h1>Your identity is being verified</h1>
                  <p>
                    Thank you for submitting your identification documents. Your documents are currently being verified.
                  </p>
                  <p>
                    You will receive an email with next steps once we have the results.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5">
            <button
              type="submit"
              onClick={handleClick}
              style={{ width: 165 }}
              className={clsx("primary mt-5 w-full sm:w-28 h-11 px-6")}>
              Go to Dashboard
            </button>
          </div>
        </div>
      </main>
    </FadeTransition>
  );
}